<!-- Intentionally empty: this component only opens the provided TemplateRef via NgbModal.
     Do not render the template inline to avoid placing the modal content in page flow. -->
<div></div>